import Badge from "../../components/Badge";
import Avatar from 'react-avatar';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";

const transactionStatusBadgeMap = {
    'CAPTURED':   'badge badge-light-success',
    'AUTHORIZED': 'badge badge-light-primary',
    'CREATED':    'badge badge-light-info',
    'REFUNDED':   'badge badge-light-warning',
    'FAILED':     'badge badge-light-danger',
    'NONE':       'badge badge-light-secondary',
};


function Transaction({transaction}) {
    const [transactionDetailsModal, setTransactionDetailsModal] = useState(false);
    const transactionDetailsModalToggle = () => setTransactionDetailsModal(!transactionDetailsModal);

    return (
        <>
            <tr>
                <td onClick={transactionDetailsModalToggle}>
                    <Link to="#" className="text-primary">{transaction.id}</Link>
                </td>
                <td>{transaction.order_number || '-'}</td>
                <td>{transaction.amount}</td>
                <td>{transaction.currency}</td>
                <td>{transaction.payment_mode}</td>
                <td>
                    <Badge
                        badge={transactionStatusBadgeMap[transaction.transaction_status] || 'badge badge-light-secondary'}
                        status={transaction.transaction_status}
                    />
                </td>
                <td>{new Date(transaction.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
            </tr>

            <Modal className={'modal-xl'} isOpen={transactionDetailsModal} toggle={transactionDetailsModalToggle}>
                <ModalHeader toggle={transactionDetailsModalToggle} close={
                    <button className="close" onClick={transactionDetailsModalToggle}>
                        &times;
                    </button>
                }>Transaction details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{transaction.id}</h4>
                        <p className="sub-header">
                            <Avatar size={95} name={transaction.id} round/>
                        </p>

                        <div className="table-responsive">
                            <table className="table mb-0">

                                <tbody>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Transaction ID</td>
                                    <td>{transaction.id}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Reference Transaction ID</td>*/}
                                {/*    <td>{transaction.reference_transaction_id}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order Number</td>
                                    <td>{transaction.order_number || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order ID</td>
                                    <td>{transaction.order}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Transaction Status</td>
                                    <td>
                                        <Badge
                                            badge={transactionStatusBadgeMap[transaction.transaction_status] || 'badge badge-light-secondary'}
                                            status={transaction.transaction_status}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Amount</td>
                                    <td>{transaction.amount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Currency</td>
                                    <td>{transaction.currency}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Payment Mode</td>
                                    <td>{transaction.payment_mode}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Bank UTR</td>*/}
                                {/*    <td>{transaction.bank_utr}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Remitter Account Number</td>*/}
                                {/*    <td>{transaction.remitter_account_number}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Remitter Account IFSC</td>*/}
                                {/*    <td>{transaction.remitter_account_ifsc}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Created</td>
                                    <td>{new Date(transaction.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(transaction.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

        </>

    );
}

export default Transaction;